var ContactUsSpotController = (function () {
    function ContactUsSpotController($scope, productContextService) {
        this.$scope = $scope;
        this.productContextService = productContextService;
    }
    ContactUsSpotController.prototype.$onInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) { _this.$scope.group = group; });
    };
    ContactUsSpotController.$inject = ['$scope', 'productContextService'];
    return ContactUsSpotController;
}());
export { ContactUsSpotController };
